<template>
  <section class="content-header">
    <h1>Rentabilidad de operarios</h1>
  </section>

  <section class="content">
    <div class="box box-primary">
      <div class="box-body">
        <div class="row">
          <div class="col-md-3">
            <div class="form-group">
              <label for="compania">Compañía</label>
              <Dropdown v-model="companyia" inputId="compania"
                :options="companyias" optionLabel="nombre" optionValue="id_companyia"
                filter placeholder="Todas las compañías" class="w-100" />
            </div>
          </div>

          <div class="col-md-3">
            <div class="form-group">
              <label for="operario">Operario</label>
              <Dropdown v-model="operario" inputId="operario"
                :options="operarios" optionLabel="nombre" optionValue="id_operario"
                filter placeholder="Todos los operarios" class="w-100" />
            </div>
          </div>

          <div class="col-md-2">
            <div class="form-group">
              <label for="empresa">Empresa</label>
              <Dropdown v-model="empresa" inputId="empresa"
                :options="empresas" optionLabel="nombre" optionValue="id_empresa"
                filter placeholder="Todas las empresas" class="w-100" />
            </div>
          </div>

          <div class="col-md-2">
            <div class="form-group">
              <label for="fecha_inicio">Fecha inicio</label>
              <Calendar v-model="fechaInicio" inputId="fecha_inicio"
                dateFormat="dd/mm/yy" showIcon class="w-100" />
            </div>
          </div>

          <div class="col-md-2">
            <div class="form-group">
              <label for="fecha_fin">Fecha fin</label>
              <Calendar v-model="fechaFin" inputId="fecha_fin"
                dateFormat="dd/mm/yy" showIcon class="w-100" />
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <div class="botonera">
              <button class="btn btn-primary" @click="cargarInforme" :disabled="generando">
                <i class="fa" :class="generando ? 'fa-spinner fa-spin' : 'fa-file-pdf-o'"></i>
                {{ generando ? 'Generando...' : 'Generar PDF' }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <form id="FormInforme" method="post" target="VentanaInforme" style="display:none"></form>
  </section>
</template>

<script>
import { PwgsApi } from '../../../services/PwgsApi';
import Dropdown from 'primevue/dropdown';
import Calendar from 'primevue/calendar';

export default {
  components: { Dropdown, Calendar },

  data() {
    const hoy = new Date();
    return {
      companyias: [],
      companyia: '',
      operarios: [],
      operario: 'all',
      empresas: [],
      empresa: '',
      fechaInicio: new Date(hoy.getFullYear(), hoy.getMonth(), 1),
      fechaFin: hoy,
      generando: false
    };
  },

  methods: {
    formatearFecha(fecha) {
      if (!fecha) return '';
      const d = String(fecha.getDate()).padStart(2, '0');
      const m = String(fecha.getMonth() + 1).padStart(2, '0');
      return `${d}/${m}/${fecha.getFullYear()}`;
    },

    // El case del PHP apunta a rentabilidad_operarios2_pdf.php y usa
    // Submit_pdf, pero el formulario real es rentabilidad_operarios_pdf.php
    // con Submit=Generar. Por eso montamos el POST directamente aquí.
    async cargarInforme() {
      window.open('', 'VentanaInforme');

      this.generando = true;
      try {
        let direccion = localStorage.getItem('direccion');
        if (direccion == 'null.pwgs.app') direccion = 'pwgs5.local';

        const form = document.getElementById('FormInforme');
        form.innerHTML = '';
        form.action = 'https://' + direccion + '/rentabilidad_operarios_pdf.php';

        const anyadir = (nombre, valor) => {
          const i = document.createElement('input');
          i.type = 'hidden';
          i.name = nombre;
          i.value = valor;
          form.appendChild(i);
        };

        anyadir('companyia', this.companyia);
        anyadir('operario', this.operario || 'all');
        anyadir('empresa', this.empresa);
        anyadir('inicio', this.formatearFecha(this.fechaInicio));
        anyadir('final', this.formatearFecha(this.fechaFin));
        anyadir('Submit', 'Generar');

        form.submit();
      } finally {
        this.generando = false;
      }
    },

    async cargarFiltros() {
      const api = new PwgsApi();
      const respuesta = await api.get('informes/rentabilidad_operarios');
      const filtros = respuesta.filtros || (respuesta.informes && respuesta.informes.filtros) || [];

      const fCompanyias = filtros.find(f => f.nombre_campo === 'id_companyia');
      const fEmpresas = filtros.find(f => f.nombre_campo === 'id_empresa');
      // Hay dos filtros con nombre_campo "id_operario" (operarios y proveedores);
      // el primero es el de operarios
      const fOperarios = filtros.filter(f => f.nombre_campo === 'id_operario')[0];

      this.companyias = fCompanyias ? fCompanyias.valores : [];
      this.companyia = '';

      this.empresas = fEmpresas ? fEmpresas.valores : [];
      this.empresa = '';

      // "Todos los operarios" se envía como "all" en este informe
      this.operarios = fOperarios ? fOperarios.valores : [];
      if (this.operarios.length && this.operarios[0].id_operario === '') {
        this.operarios[0] = { id_operario: 'all', nombre: 'Todos los operarios' };
      }
      this.operario = 'all';
    }
  },

  mounted() {
    this.cargarFiltros();
  }
};
</script>

<style scoped>
.form-group label {
  display: block;
  font-weight: 600;
  margin-bottom: 5px;
}

.w-100 :deep(.p-dropdown),
.w-100 :deep(.p-calendar),
.w-100 :deep(.p-inputtext) {
  width: 100%;
}

.botonera {
  display: flex;
  align-items: center;
  gap: 8px;
}
</style>